import React, { Component } from 'react';
import CheckboxSection from "./CheckboxSection";

const ConfiguracionAvanzadaActiveDirectory = (props) => {
    return (
        <div className="row">
            <div className="col-xs-12">
                <h3>Configuración avanzada</h3>
            </div>

            <div className="col-xs-12">

                <div className="row row-radio">
                    <div className="col-xs-12">
                        <div className="container-radio radio-margin">
                            <input id="soloUsuarioLoggeado2" type="radio" name="group1" checked={props.soloUsuarioLoggeado} />
                            <label className="lbl-radio label-secondary" style={{ cursor: 'default' }}>
                                Solo el usuario logueado en Windows puede iniciar sesión en los sistemas “G&F”.
                            </label>
                        </div>
                    </div>
                </div>

                <div className="left-separator-xs">
                    <CheckboxSection message="Debe volver a ingresar la contraseña de Windows cada vez que inicie sesión en los sistemas “G&F”."
                        isChecked={props.solicitarContrasenia}
                        identifier="solicitarContrasenia"/>
                </div>

                <div className="row row-radio">
                    <div className="col-xs-12">
                        <div className="container-radio radio-margin">
                            <input id="soloUsuarioLoggeado" type="radio" name="group1" checked={!props.soloUsuarioLoggeado} />
                            <label className="lbl-radio label-secondary" style={{cursor: 'default' }}>
                                Permitir que otros usuarios de Windows puedan iniciar sesión en los sistemas “G&F” en una terminal cuya sesión es de otro usuario.
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfiguracionAvanzadaActiveDirectory;
